@import '../../theme/global';

snap-input {
  @include box-sizing;
  @include reset-inputs;
  @include reset-input-type;
  @include button-reset;

  font-family: $font-family;

  .snap-input {
    @include text-size(sm);
  }

  .label {
    color: $gray-700;
    display: block;
    font-size: 0.875rem;
    font-weight: 500;
    line-height: 1.25rem;
  }

  .sr-only {
    @include sr-only;
  }

  .basic-span {
    color: $gray-500;
    @media (max-width: map-get($breakpoints, 'sm')) {
      line-height: 1.25rem;
    }
  }

  .corner-hint {
    display: flex;
    justify-content: space-between;
  }

  .help-text {
    color: $gray-500;
    display: flex;
    font-weight: 400;
    justify-content: space-between;
    line-height: 1.25rem;
    margin-top: 0.25rem;
    @include text-size(sm);

    p {
      margin: 0;
    }
  }

  .required {
    color: $red-500;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    margin-left: 0.25rem;
  }

  input.snap-input {
    border-color: $gray-300;
    border-radius: 0.625rem;
    box-shadow: $box-shadow-small;
    color: $gray-800;
    display: block;
    font-size: 1rem;
    line-height: 1.5rem;
    width: 100%;

    @media (min-width: map-get($breakpoints, 'md')) {
      font-size: 0.875rem;
      line-height: 1.25rem;
    }

    &:focus {
      border-color: $blue-600;
      box-shadow: 0 0 0 1px $blue-600, 0 1px 2px rgba(0, 0, 0, 0.05);
    }

    &.hideColor {
      color: transparent;
    }
  }

  snap-link .snap-link {
    color: $blue-600;
    font-weight: 700;
    margin-bottom: 0.25rem;
    margin-top: 0.25rem;
    text-decoration: none;
  }

  &[textarea] {
    .input-container snap-icon {
      bottom: auto;
      top: 0.5rem;

      + textarea {
        padding-right: 2.25rem;
      }
    }
  }

  .snap-input-textarea {
    border-radius: 0.625rem;
    box-shadow: $box-shadow-small;
    display: block;
    font-size: 1rem;
    line-height: 1.5rem;
    width: 100%;

    @media (min-width: map-get($breakpoints, 'md')) {
      font-size: 0.875rem;
      line-height: 1.25rem;
    }

    &-submit {
      height: 3rem;
      min-height: 3rem;
      overflow-y: hidden;
      padding: 12px 57px 12px 13px;
      resize: none;


      @media (min-width: map-get($breakpoints, 'md')) {
        padding: 14px 56px 14px 13px;
      }
    }

    &:focus {
      border-color: $blue-500;
      box-shadow: 0 0 0 1px $blue-500, 0 1px 2px rgba(0, 0, 0, 0.05);
    }
  }

  .input-container {
    margin-top: 0.25rem;
    position: relative;

    &.error {
      textarea,
      .snap-input {
        border-color: $red-500;
        padding-right: 2.5rem;

        &:focus,
        &:focus-visible {
          border-color: $blue-600;
          box-shadow: 0 0 0 1px $blue-600, 0 1px 2px rgba(0, 0, 0, 0.05);
        }
      }

      snap-icon[icon='exclamation-circle-solid'] {
        color: $red-500;
      }
    }

    &.success {
      textarea,
      .snap-input {
        border-color: $green-500;

        &:focus {
          border-color: $green-500;
          outline: 0;
        }
      }

      snap-icon[icon='check-circle-solid'] {
        color: $green-500;
      }
    }

    > snap-icon {
      align-items: center;
      bottom: 0;
      color: $gray-400;
      display: flex;
      padding-right: 0.75rem;
      pointer-events: none;
      position: absolute;
      right: 0;
      top: 0;

      + .snap-input {
        padding-right: 2.5rem;
      }
    }

    &.password > snap-icon {
      right: 50px;
    }

    &.left {
      snap-icon:not(.password-icon):not(.info-icon) {
        left: 0;
        padding-left: 0.75rem;
        padding-right: 0;
        right: auto;
      }

      .snap-input:has(+ .input-select-class) {
        padding-left: 5.5rem;

      }

      .snap-input {
        padding-left: 2.5rem;
        padding-right: 0.75rem;
      }

      & button:not(.password-btn) {
        align-items: center;
        background-color: $gray-50;
        border-bottom-right-radius: 0.625rem;
        border-color: $gray-300;
        border-top-right-radius: 0.625rem;
        border-width: 1px;
        display: inline-flex;
        font-size: 0.875rem;
        font-weight: 500;
        line-height: 1.25rem;
        margin-left: 0.5rem;
        padding: 0.5rem 1rem;
        position: relative;

        &:hover {
          background-color: $gray-100;
        }

        &:focus {
          border-color: $blue-500;
          box-shadow: 0 0 0 0 1px $blue-500;
          outline: 0;
        }
      }

      .input-select {
        border-left: 0;
        border-right: 1px solid $gray-300;
        left: 0;
        right: auto;
      }
    }

    &.addon {
      &.default {
        display: flex;
        @include text-size(sm);

        .prepend {
          align-items: center;
          background-color: $gray-50;
          border-bottom-left-radius: 0.625rem;
          border-color: $gray-300;
          border-top-left-radius: 0.625rem;
          border-width: 1px;
          border-right-width: 0;
          color: $gray-500;
          display: inline-flex;
          padding-left: 0.75rem;
          padding-right: 0.75rem;
          @media (max-width: map-get($breakpoints, 'sm')) {
            line-height: 1.25rem;
          }

          + .snap-input {
            border-radius: 0 0.625rem 0.625rem 0;
            box-shadow: none;
            flex: 1 1 0;
            min-width: 0;
            padding: 0.5rem 0.75rem;
          }
        }
      }

      &.basic {
        @include text-size(sm);

        .prepend {
          align-items: center;
          bottom: 0;
          display: flex;
          left: 0;
          padding-left: 0.75rem;
          pointer-events: none;
          position: absolute;
          top: 0;

          + .snap-input {
            padding-left: 4.5rem;
            @media (max-width: map-get($breakpoints, 'sm')) {
              padding-left: 4rem;
            }
          }
        }

        .append {
          align-items: center;
          bottom: 0;
          display: flex;
          padding-right: 0.75rem;
          pointer-events: none;
          position: absolute;
          right: 0;
          top: 0;
        }

        &.combo {
          .snap-input {
            padding-left: 1.75rem;
            padding-right: 3rem;
          }
        }
      }
    }

    & select {
      background-color: transparent;
      border-color: transparent;
      border-radius: 0.625rem;
      color: $gray-500;
      height: 100%;
      padding: 0 1.75rem 0 0.75rem;
      position: absolute;

      &:focus {
        border-color: $blue-500;
        box-shadow: 0 0 0 1px $blue-500, 0 1px 2px rgba(0, 0, 0, 0.05);
      }

      @media (max-width: map-get($breakpoints, 'sm')) {
        line-height: 1.25rem;
      }

      + .snap-input {
        padding-left: 4.5rem;
        @media (max-width: map-get($breakpoints, 'sm')) {
          padding-left: 4rem;
        }
      }
    }

    &.right.addon.basic {
      select {
        right: 0;

        + .snap-input {
          padding-left: 1.75rem;
          padding-right: 3rem;
        }
      }
    }

    &.password {
      align-items: stretch;
      display: flex;

      &:focus-visible {
        outline: none;
      }

      .snap-input {
        padding-right: 3.438rem;
      }

      snap-icon.password-btn {
        right: 3.438rem;
      }

      &.success,
      &.error {
        .snap-input {
          padding-right: 6rem;
        }

        & > snap-icon.info-icon {
          right: 3.125rem;
        }
      }
    }

    &.password-show {
      .password-btn {
        background-color: $blue-100;
      }
    }

    &.clear-input {
      .snap-input {
        padding-right: 4.063rem;
      }

      &.success,
      &.error {
        .snap-input {
          padding-right: 6rem;
        }

        snap-icon {
          right: 3.125rem;
        }
      }
    }

    &.disabled,
    &.locked {
      .snap-input {
        background-color: $gray-100;
      }
    }

    &.locked {
      .snap-input::placeholder {
        color: $gray-800;
      }
    }

    .password-btn {
      align-items: center;
      border-bottom-right-radius: 0.56rem;
      border-left: 1px solid $gray-300;
      border-top-right-radius: 0.56rem;
      cursor: pointer;
      display: flex;
      height: calc(100% - 2px);
      margin-right: 1px;
      padding: 8px 17px 8px 15px;
      position: absolute;
      right: 0;
      top: 1px;
    }

    .clear-input-btn {
      border-bottom-right-radius: 0.56rem;
      border-left: 1px solid $gray-300;
      border-top-right-radius: 0.56rem;
      cursor: pointer;
      display: flex;
      margin-right: 1px;
      padding: 8px 17px 8px 15px;
      position: absolute;
      right: 0;
      top: 1px;
    }

    .input-btn {
      border-bottom-right-radius: 0.56rem;
      border-left: 1px solid $gray-300;
      border-top-right-radius: 0.56rem;
      cursor: pointer;
      display: flex;
      height: calc(100% - 2px);
      margin-right: 1px;
      position: absolute;
      right: 0;
      top: 1px;

      &[disabled] {
        cursor: none;
        pointer-events: none;
      }
    }

    .input-select {
      appearance: none;
      background-size: .65em auto, 100%;
      border-left: 1px solid $gray-300;
      border-radius: 0;
      cursor: pointer;
      display: flex;
      margin-right: 1px;
      padding: 7px;
      position: absolute;
      right: 0;
      top: 1px;
    }

    .snap-input-textarea-btn-container {
      bottom: 0;
      cursor: pointer;
      display: none;
      padding: 7px;
      position: absolute;
      right: 0;

      &.show {
        display: block;
      }

      @media (min-width: map-get($breakpoints, 'md')) {
        bottom: 7px;
        padding: 0;
        right: 7px;
      }
    }
  }

  .input-select-class {
    display: flex;
  }

  .character-counter {
    color: #6b7280;
    display: flex;
    justify-content: flex-end;
    line-height: 1.25rem;
  }

  .snap-auth-input-label-helper-link {
    margin-top: 0.25rem;

    button.snap-button {
      background-color: transparent;
      border-width: 0;
      box-shadow: none;
      color: $blue-600;
      font-size: 1rem;
      font-weight: 700;
      line-height: 1.5rem;
      padding: 0;

      &:focus {
        box-shadow: none;
        outline: 0;
      }

      &:active {
        box-shadow: none;
      }
    }
  }

  .error-description {
    @include text-size(sm);
    color: $red-600;
    font-weight: 400;
  }
}
